/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "jestere",
        "-2": "vörjestere",
        "0": "hück",
        "1": "morje",
        "2": "övvermorje",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-narrow": {
        "-1": "jestere",
        "-2": "vörjestere",
        "0": "hück",
        "1": "morje",
        "2": "övvermorje",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-short": {
        "-1": "jestere",
        "-2": "vörjestere",
        "0": "hück",
        "1": "morje",
        "2": "övvermorje",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "month": {
        "-1": "lätzde Mohnd",
        "0": "diese Mohnd",
        "1": "nächste Mohnd",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-narrow": {
        "-1": "lätzde Mohnd",
        "0": "diese Mohnd",
        "1": "nächste Mohnd",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-short": {
        "-1": "lätzde Mohnd",
        "0": "diese Mohnd",
        "1": "nächste Mohnd",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "week": {
        "-1": "läz Woch",
        "0": "di Woch",
        "1": "nächste Woche",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-narrow": {
        "-1": "läz Woch",
        "0": "di Woch",
        "1": "nächste Woche",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-short": {
        "-1": "läz Woch",
        "0": "di Woch",
        "1": "nächste Woche",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "year": {
        "-1": "läz Johr",
        "0": "diß Johr",
        "1": "näx Johr",
        "future": {
          "one": "en {0} Johr",
          "other": "en {0} Johre",
          "zero": "en keinem Johr"
        },
        "past": {
          "one": "vör {0} Johr",
          "other": "vör {0} Johre",
          "zero": "vör keijnem Johr"
        }
      },
      "year-narrow": {
        "-1": "läz Johr",
        "0": "diß Johr",
        "1": "näx Johr",
        "future": {
          "one": "en {0} Johr",
          "other": "en {0} Johre",
          "zero": "en keinem Johr"
        },
        "past": {
          "one": "vör {0} Johr",
          "other": "vör {0} Johre",
          "zero": "vör keijnem Johr"
        }
      },
      "year-short": {
        "-1": "läz Johr",
        "0": "diß Johr",
        "1": "näx Johr",
        "future": {
          "one": "en {0} Johr",
          "other": "en {0} Johre",
          "zero": "en keinem Johr"
        },
        "past": {
          "one": "vör {0} Johr",
          "other": "vör {0} Johre",
          "zero": "vör keijnem Johr"
        }
      }
    },
    "locale": "ksh"
  });
}